var _line, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterGradientLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 1,
    viewBox: "0 0 277 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 0.5,
    x2: 277,
    y2: 0.500024,
    stroke: "url(#paint0_linear_457_755)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_457_755",
    x1: 0,
    y1: 1,
    x2: 0.95695,
    y2: 17.0226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterGradientLine);
export default __webpack_public_path__ + "static/media/footer-gradient-line.6a703746d5765f094b85fccd26a5d988.svg";
export { ForwardRef as ReactComponent };